/**
 * Route for `campaign-dayparting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignDaypartingPage } from "../features/campaign-dayparting/CampaignDaypartingPage";

export const campaignDaypartingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-dayparting",
	component: CampaignDaypartingPage,
});

export default campaignDaypartingRoute;
